"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[22647],{

/***/ 74575:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    mobileS: "(min-width:320px)",
    mobileM: "(min-width:375px)",
    mobileL: "(min-width:425px)",
    tablet: "(min-width:768px)",
    laptop: "(min-width:1024px)",
    laptopL: "(min-width:1440px)",
    desktop: "(min-width:2560px)"
});


/***/ }),

/***/ 84607:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 *
 * @param {number} percentNum - accept value 0 until 100
 * eg:
 * import hexOpacity from "./hexOpacity";
 *
 * ...
 * ...
 *  color: ${color.primary + hexOpacity(80)}
 * ...
 *
 */ var percentToHex = function() {
    var percentNum = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return Math.round(percentNum / 100 * 255).toString(16).padStart(2, "0");
};
/* harmony default export */ __webpack_exports__["Z"] = (percentToHex);


/***/ }),

/***/ 70524:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var RUNNING_TRADE = {
    SEARCH_INPUT: "running-trade-search-input",
    SEARCH_INPUT_CLEAR_BUTTON: "running-trade-search-input-clear-button"
};
var CALENDAR = {
    HEADER_MORE_BUTTON: "calendar-header-more-button",
    ROW_SYMBOL: "calendar-row-symbol"
};
var PROFILE = {
    HEADER_MORE_BUTTON: "profile-header-more-button",
    HEADER_BLOCK_BUTTON: "profile-header-block-button"
};
var CHATROOM = {
    GROUP_MEMBER: "chatroom-group-member",
    SEND_MESSAGE_BUTTON: "chatroom-send-message-button",
    CONFIRM_DELETE_MESSAGE_BUTTON: "chatroom-confirm-delete-message-button",
    CAPSULE_USER_NEW_GROUP: "chatroom-capsule-user-new-group",
    CAPSULE_USER_NEW_GROUP_CLOSE: "chatroom-capsule-user-new-group-close",
    SUGGESTED_USER: "chatroom-suggested-user"
};
var COMPANY = {
    NAVBAR_MORE_MENU: "company-navbar-more-menu",
    WIDGET_CATALOG: "company-widget-catalog",
    WIDGET_CATALOG_ITEM: "company-widget-catalog-item",
    WIDGET_INVESTMENT_MORE_BUTTON: "company-widget-investment-more-button"
};
var NOTIFICATION = {
    TITLE_TEXT: "notification-title-text"
};
var VALUATION = {
    HEADER_TITLE: "valuation-header-title",
    HEADER_MORE_BUTTON: "valuation-header-more-button"
};
var NAVIGATION = {
    MORE_MENU_BUTTON: "navigation-more-menu-button"
};
var GLOSSARY = {
    SEARCH_SUGGESTION: "glossary-search-suggestion"
};
var SHARE_POST = {
    CHECKBOX: "share-post-checkbox",
    SEND_BUTTON: "share-post-send-button"
};
var STREAM_POST = {
    CONFIRM_DELETE_BUTTON: "stream-post-confirm-delete-button",
    CONFIRM_CANCEL_BUTTON: "stream-post-confirm-cancel-button"
};
var EARNINGS = {
    SEARCH_SYMBOL_INPUT: "earnings-search-symbol-input",
    SEARCH_SYMBOL_BUTTON: "earnings-search-symbol-button",
    TABLE_ROW_SYMBOL: "earnings-table-row-symbol"
};
var FINANCIALS = {
    TABLE_TITLE_TEXT: "financials-table-title-text",
    TABLE_QUARTER_TEXT: "financials-table-quarter-text",
    TABLE_INCOME_TEXT: "financials-table-income-text"
};
var SCREENER = {
    DELETE_RULES_BUTTON: "screener-delete-rules-button",
    CLOSE_POPUP_BUTTON: "screener-close-popup-button",
    STOCK_SEARCH_INPUT: "screener-stock-search-input"
};
var LANDING = {
    REGISTER_BUTTON: "landing-register-button",
    LOGIN_BUTTON: "landing-login-button"
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    RUNNING_TRADE: RUNNING_TRADE,
    CALENDAR: CALENDAR,
    PROFILE: PROFILE,
    CHATROOM: CHATROOM,
    COMPANY: COMPANY,
    NOTIFICATION: NOTIFICATION,
    VALUATION: VALUATION,
    NAVIGATION: NAVIGATION,
    GLOSSARY: GLOSSARY,
    SHARE_POST: SHARE_POST,
    STREAM_POST: STREAM_POST,
    EARNINGS: EARNINGS,
    FINANCIALS: FINANCIALS,
    SCREENER: SCREENER,
    LANDING: LANDING
});


/***/ }),

/***/ 44252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BP": function() { return /* binding */ REGISTRATION_DATA; },
/* harmony export */   "Nv": function() { return /* binding */ REFRESH_TOKEN_KEY_EXP; },
/* harmony export */   "Wx": function() { return /* binding */ ACCESS_TOKEN_KEY; },
/* harmony export */   "ns": function() { return /* binding */ ACCESS_USER_KEY; },
/* harmony export */   "w4": function() { return /* binding */ REFRESH_TOKEN_KEY; },
/* harmony export */   "z0": function() { return /* binding */ ACCESS_TOKEN_KEY_EXP; }
/* harmony export */ });
var ACCESS_TOKEN_KEY = "at";
var ACCESS_TOKEN_KEY_EXP = "ate";
var REFRESH_TOKEN_KEY = "ar";
var REFRESH_TOKEN_KEY_EXP = "are";
var ACCESS_USER_KEY = "au";
var REGISTRATION_DATA = "registerData";


/***/ }),

/***/ 16681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ER": function() { return /* binding */ fadeInRight; },
/* harmony export */   "E_": function() { return /* binding */ fadeInTop; },
/* harmony export */   "Ji": function() { return /* binding */ fadeIn; },
/* harmony export */   "O2": function() { return /* binding */ fadeInLeft; },
/* harmony export */   "d7": function() { return /* binding */ fadeInDown; },
/* harmony export */   "hb": function() { return /* binding */ fromRight; },
/* harmony export */   "tn": function() { return /* binding */ logoCompanyAnimated; },
/* harmony export */   "wK": function() { return /* binding */ scaleUp; }
/* harmony export */ });
/* unused harmony export animatedlogo */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
/* eslint-disable no-tabs */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	from {\n		opacity: 0;\n		transform-origin: left top;\n		transform: scale(1);\n	}\n	50% {\n		transform-origin: left top;\n		transform: translate3d(-10px, -20px, 0);\n	}\n	to {\n		transform-origin: left top;\n		transform: scale(0.7) translate3d(0, 0, 0);\n		opacity: 1;\n	}"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	from {\n		opacity: 0;\n	}\n	to {\n		opacity: 1;\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	from {opacity: 0; transform: translate3d(-5%, 0, 0);}\n	to {opacity: 1;transform: none;}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from {opacity: 0;transform: translateX(40px);}\n	to {opacity: 1;transform: translateX(0);}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	from {\n		opacity: 0;\n		transform: translate3d(50px, 0, 0);\n	}\n	to {\n		opacity: 1;\n		transform: none;\n	}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	from {\n		opacity: 0;\n		transform: translate3d(-100px, 0, 0);\n	}\n	to {\n		opacity: 1;\n		transform: none;\n	}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	from {\n		opacity: 0;\n		transform: translate3d(0, -50px, 0);\n	}\n	to {\n		opacity: 1;\n		transform: translate3d(0, 0, 0);\n	}\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	from {\n		transform: scale(0.9);\n		opacity: 0;\n	}\n	50% {\n		transform: scale(1.1);\n	}\n	to {\n		transform: scale(1);\n		opacity: 1;\n	}\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	from {\n		filter: grayscale(100%);\n		opacity: 0.4;\n		transform: scale(0.9);\n	}\n	50% {\n		filter: grayscale(100%);\n		transform: scale(1.1);\n	}\n	to {\n		filter: grayscale(10%);\n		opacity: 1;\n		transform: scale(1);\n	}\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var animatedlogo = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject());
var fadeIn = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject1());
var fadeInDown = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject2());
var fromRight = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject3());
var fadeInRight = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject4());
var fadeInLeft = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject5());
var fadeInTop = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject6());
var scaleUp = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject7());
var logoCompanyAnimated = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject8());



/***/ }),

/***/ 51346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ku": function() { return /* binding */ localStorageOrderbookHandler; },
/* harmony export */   "M6": function() { return /* binding */ transformNewOrderbookListToExisting; },
/* harmony export */   "g8": function() { return /* binding */ memoizeChild; }
/* harmony export */ });
/* unused harmony export getErrorMessage */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var localStorageOrderbookHandler = {
    get: function() {
        var orderbookName = localStorage.getItem("orderbooklistName");
        var orderbookID = localStorage.getItem("orderbooklistID");
        return {
            orderbookName: orderbookName,
            orderbookID: orderbookID
        };
    },
    set: function(orderbookName, orderbookID) {
        localStorage.setItem("orderbooklistID", orderbookID);
        localStorage.setItem("orderbooklistName", orderbookName);
    },
    remove: function() {
        localStorage.removeItem("orderbooklistID");
        localStorage.removeItem("orderbooklistName");
    }
};
var getErrorMessage = function(error) {
    var ref;
    var err = _instanceof(error, Error) ? (error === null || error === void 0 ? void 0 : (ref = error.cause) === null || ref === void 0 ? void 0 : ref.message) || error.message : String(error);
    return err;
};
var memoizeChild = function(component) {
    var circular = function() {
        var seen = new WeakSet();
        return function(key, value) {
            if (key.startsWith("_")) return; // Don't compare React's internal props.
            if (typeof value === "object" && value !== null) {
                if (seen.has(value)) return;
                seen.add(value);
            }
            // eslint-disable-next-line consistent-return
            return value;
        };
    };
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(component, function(prevProps, nextProps) {
        var prev = JSON.stringify(prevProps, circular());
        var next = JSON.stringify(nextProps, circular());
        return prev === next;
    });
};
var transformNewOrderbookListToExisting = function(newResponse) {
    var tradeable = newResponse.tradable ? 1 : 0;
    var bidObject = {};
    var offerObject = {};
    newResponse.bid.forEach(function(value, index) {
        var priceNameKey = "price".concat(index + 1);
        bidObject[priceNameKey] = value.price;
        var queNumNameKey = "que_num".concat(index + 1);
        bidObject[queNumNameKey] = value.que_num;
        var valueNameKey = "volume".concat(index + 1);
        bidObject[valueNameKey] = value.volume;
    });
    newResponse.offer.forEach(function(value, index) {
        var priceNameKey = "price".concat(index + 1);
        offerObject[priceNameKey] = value.price;
        var queNumNameKey = "que_num".concat(index + 1);
        offerObject[queNumNameKey] = value.que_num;
        var valueNameKey = "volume".concat(index + 1);
        offerObject[valueNameKey] = value.volume;
    });
    return {
        id: newResponse.id,
        symbol: newResponse.symbol,
        symbol_2: newResponse.symbol,
        symbol_3: newResponse.symbol,
        name: newResponse.name,
        status: newResponse.status,
        lastprice: newResponse.lastprice,
        previous: newResponse.previous,
        change: newResponse.change,
        percentage_change: newResponse.percentage_change,
        open: newResponse.open,
        high: newResponse.high,
        low: newResponse.low,
        close: newResponse.close,
        volume: newResponse.volume,
        value: newResponse.value,
        average: newResponse.average,
        bid: bidObject,
        offer: offerObject,
        frequency: newResponse.frequency,
        fbuy: newResponse.fbuy,
        fsell: newResponse.fsell,
        fnet: newResponse.fnet,
        fpercent: newResponse.fpercent,
        tradeable: tradeable,
        notation: newResponse.notation,
        uma: newResponse.uma,
        GUID: null,
        is_foreignbs_exist: newResponse.has_foreign_bs,
        exchange: newResponse.exchange,
        country: null,
        foreign: null,
        domestic: null,
        up: null,
        down: null,
        unchanged: null,
        iepiev: newResponse.iepiev,
        ara: newResponse.ara,
        arb: newResponse.arb,
        company_type: newResponse.company_type,
        corp_action: newResponse.corp_action,
        market_data: newResponse.market_data,
        auto_reject_estimation: newResponse.auto_reject_estimation
    };
};


/***/ }),

/***/ 81545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "US": function() { return /* binding */ FAQContainer; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "vQ": function() { return /* binding */ ButtonRegister; },
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* unused harmony export RegisterLoginWrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var features_home_page_keyframes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16681);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74575);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: calc(100% - 50px);\n  margin: 50px auto;\n  @media ",
        " {\n    max-width: 1300px;\n    width: calc(100% - 150px);\n  }\n\n  .scaleUpX {\n    opacity: 0;\n  }\n\n  .scaleUp {\n    animation-duration: 0.6s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: var(--light-font);\n  font-size: 17px;\n\n  @media ",
        " {\n    font-size: 19px;\n  }\n\n  a {\n    color: ",
        ";\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n\n  .text {\n    font-family: 'ProximaNovaLt';\n\n    a {\n      color: #00ab6b;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  border-radius: 4px;\n  color: ",
        ";\n  display: inline-flex;\n  font-family: var(--bold-font);\n  font-size: 18px;\n  height: 50px;\n  margin: 30px 0;\n  padding: 0 10px;\n  transition: background-color 0.2s ease;\n  -webkit-transition: background-color 0.2s ease;\n  -moz-transition: background-color 0.2s ease;\n  text-transform: uppercase;\n\n  @media ",
        " {\n    margin: 50px 0;\n    padding: 0 50px;\n  }\n\n  &:hover {\n    background-color: #222;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: repeat(2, 1fr);\n  grid-column-gap: 0px;\n  grid-row-gap: 0px;\n  width: 100%;\n\n  @media ",
        " {\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: 1fr;\n    grid-column-gap: 60px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    direction: "column",
    align: "center"
}).withConfig({
    componentId: "sc-8c29d6c9-0"
})(_templateObject(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet, features_home_page_keyframes__WEBPACK_IMPORTED_MODULE_1__/* .scaleUp */ .wK);
var Text = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs({
    align: "center",
    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].highempahis */ .Z.highempahis
}).withConfig({
    componentId: "sc-8c29d6c9-1"
})(_templateObject1(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary);
var RegisterLoginWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8c29d6c9-2"
})(_templateObject2());
var ButtonRegister = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-8c29d6c9-3"
})(_templateObject3(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light);
var FAQContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-8c29d6c9-4"
})(_templateObject4(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);



/***/ }),

/***/ 56670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hn": function() { return /* binding */ copyrightLinks; },
/* harmony export */   "IJ": function() { return /* binding */ menus; },
/* harmony export */   "J7": function() { return /* binding */ FAQs; },
/* harmony export */   "dk": function() { return /* binding */ footerLinks; },
/* harmony export */   "ju": function() { return /* binding */ downloadLinks; },
/* harmony export */   "v7": function() { return /* binding */ socialMediaLinks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86123);


var menus = [
    {
        title: "Desktop App",
        url: "/desktop"
    },
    {
        title: "Investing",
        url: "/info/mulai-investasi"
    },
    {
        title: "Pro Tools",
        url: "/info/pro-tools"
    },
    {
        title: "Academy",
        url: "https://academy.stockbit.com/"
    },
    {
        title: "About Us",
        url: "/about"
    },
    {
        title: "Blog",
        url: "https://blog.stockbit.com/"
    },
    {
        title: "Career",
        url: "https://careers.stockbit.com"
    },
    {
        title: "Help",
        url: "https://help.stockbit.com/"
    }, 
];
var footerLinks = [
    {
        title: "About Us",
        url: "/about"
    },
    {
        title: "Contact",
        url: "/contact"
    },
    {
        title: "Help",
        url: "https://help.stockbit.com"
    },
    {
        title: "Kamus Saham",
        url: "/glossary"
    },
    {
        title: "House Rules",
        url: "/rules"
    },
    {
        title: "Terms",
        url: "/terms"
    },
    {
        title: "Privacy",
        url: "/privacy"
    },
    {
        title: "Tata Kelola",
        url: "/tatakelola"
    }, 
];
var prefix = "".concat(constants_app__WEBPACK_IMPORTED_MODULE_1__/* .assetPrefix */ .Vc, "/images");
var socialMediaLinks = [
    {
        title: "Facebook",
        url: "https://www.facebook.com/Stockbit/",
        imageUrl: "".concat(prefix, "/facebook.png")
    },
    {
        title: "Twitter",
        url: "https://twitter.com/Stockbit",
        imageUrl: "".concat(prefix, "/twitter.png")
    },
    {
        title: "Instagram",
        url: "https://www.instagram.com/stockbit/",
        imageUrl: "".concat(prefix, "/instagram.png")
    }, 
];
var downloadLinks = [
    {
        title: "Available on the App Store",
        url: "https://itunes.apple.com/us/app/stockbit/id1184800207?mt=8",
        imageUrl: "".concat(prefix, "/appstore-logo.png")
    },
    {
        title: "Available on Google Play",
        url: "https://play.google.com/store/apps/details?id=com.stockbit.android&amp;hl=en",
        imageUrl: "".concat(prefix, "/playstore-logo.png")
    }, 
];
var copyrightLinks = [
    {
        title: "IDX",
        imageUrl: "".concat(prefix, "/logo-idx.svg"),
        description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                "Anggota Bursa",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                "Efek Indonesia"
            ]
        })
    },
    {
        title: "KSEI",
        imageUrl: "".concat(prefix, "/logo-ksei.svg"),
        description: "Terdaftar di Kustodian Sentral Efek Indonesia"
    },
    {
        title: "IDclear",
        imageUrl: "".concat(prefix, "/logo-idclear.svg"),
        description: "Terdaftar di Kliring Penjaminan Efek Indonesia"
    },
    {
        title: "SIPF",
        imageUrl: "".concat(prefix, "/logo-sipf.svg"),
        description: "Anggota Dana Perlindungan Modal"
    },
    {
        title: "3PIDX",
        imageUrl: "".concat(prefix, "/logo-3p.svg"),
        description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                "Mendukung",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                "Program 3P IDX.",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                "Paham Punya Pantau"
            ]
        })
    },
    {
        title: "LAPSSJK",
        imageUrl: "".concat(prefix, "/logo-laps.svg"),
        description: "Terdaftar di LAPS SJK Sektor Jasa Keuangan"
    }, 
];
var FAQs = [
    {
        q: "Apakah ada biaya bulanan?",
        a: "Tidak ada biaya bulanan yang dikenakan untuk bertransaksi melalui Stockbit."
    },
    {
        q: "Berapa lama proses pembukaan rekening saham?",
        a: "Proses pembukaan rekening saham membutuhkan waktu kurang lebih 1 hari kerja."
    },
    {
        q: "Berapa lama proses deposit dan withdrawal dana?",
        a: "Pada saat jam bursa, dana akan terupdate dalam waktu sekitar 15 menit setelah anda mentransfer dana ke RDN Anda. Untuk withdrawal, umumnya membutuhkan waktu 1-2 hari bursa."
    },
    {
        q: "Berapa fee transaksi yang berlaku?",
        a: "Fee beli 0,15% dan fee jual 0,25%."
    },
    {
        q: "Dari mana saya bisa bertransaksi saham?",
        a: "Kamu dapat bertransaksi saham melalui aplikasi mobile dan website Stockbit."
    },
    {
        q: "Apakah ada fitur Auto Order (Trailing Stop, Stop Loss, GTC, dsb)?",
        a: "Untuk saat ini belum ada fitur otomatis, Anda dapat memasangnya secara manual."
    },
    {
        q: "Apakah tetap bisa membuka rekening jika tidak memiliki NPWP?",
        a: "Kamu tetap bisa membuka rekening meskipun tidak memiliki NPWP."
    },
    {
        q: "Bagaimana jika sebelumnya sudah memiliki RDN?",
        a: "Anda diwajibkan untuk membuka RDN baru agar bisa bertransaksi di Stockbit."
    }, 
];



/***/ }),

/***/ 22647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ global_HomePageLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
;// CONCATENATED MODULE: ./src/global/HomePageLayout/Footer/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 27px 20px;\n\n  @media ",
        " {\n    padding: 50px 30px;\n  }\n  @media ",
        " {\n    padding: 80px 0 50px 0;\n  }\n  &.bg-white {\n    background-color: #ffffff;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 40px 0 35px;\n\n  @media ",
        " {\n    width: 90%;\n    padding: 0px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1300px;\n  margin: auto;\n\n  @media ",
        " {\n    padding: 20px 0;\n  }\n\n  @media ",
        " {\n    width: calc(100% - 150px);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 74px;\n  display: ",
        ";\n\n  @media ",
        " {\n    display: ",
        ";\n    width: auto;\n    height: 54px;\n  }\n\n  @media ",
        " {\n    height: 77px;\n    width: 141px;\n    object-fit: contain;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n\n  @media ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #777;\n  font-family: var(--regular-font);\n  font-size: 14px;\n  padding-bottom: 6px;\n\n  @media ",
        " {\n    padding-bottom: 10px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  width: 100px;\n\n  @media ",
        " {\n    display: ",
        ";\n  }\n\n  @media ",
        " {\n    display: ",
        ";\n  }\n\n  & img {\n    filter: grayscale(1);\n    height: 17px;\n\n    @media ",
        " {\n      height: 20px;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  @media ",
        " {\n    display: block;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: flex-start;\n  flex-direction: row;\n  justify-items: space-between;\n\n  .hidden-navs {\n    display: flex;\n  }\n\n  @media ",
        " {\n    align-items: center;\n    order: unset;\n  }\n\n  @media ",
        " {\n    .hidden-navs {\n      display: none;\n    }\n  }\n\n  ",
        " {\n    @media ",
        " {\n      align-items: flex-start;\n    }\n  }\n\n  a {\n    color: inherit;\n    font-size: 14px;\n    text-decoration: none;\n    margin-bottom: 10px;\n\n    &:hover {\n      color: #777;\n    }\n\n    @media ",
        " {\n      color: ",
        ";\n      line-height: 1.15;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  order: 1;\n\n  @media ",
        " {\n    order: unset;\n  }\n\n  img {\n    margin-bottom: 12px;\n  }\n\n  p {\n    color: inherit;\n    font-size: 14px;\n    text-decoration: none;\n    line-height: 20px;\n    padding: 5px 0;\n\n    @media ",
        " {\n      color: ",
        ";\n      margin-bottom: 10px;\n      line-height: 1.15;\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  align-items: center;\n  flex-direction: column-reverse;\n  padding: 50px 25px;\n  width: 100%;\n  max-width: 1300px;\n\n  @media ",
        " {\n    flex-direction: row;\n    justify-content: space-between;\n    padding: 50px 0px;\n    width: calc(100% - 150px);\n    ",
        "\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    filter: grayscale(",
        ");\n    object-fit: contain;\n    height: 60px;\n    width: 40px;\n    margin: auto;\n\n    @media ",
        " {\n      width: 80px;\n      height: 80px;\n    }\n\n    @media ",
        " {\n      width: 120px;\n      height: 120px;\n    }\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  display: none;\n  color: ",
        ";\n  @media ",
        " {\n    display: block;\n    font-size: 8px;\n  }\n\n  @media ",
        " {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 164px;\n  opacity: 0.5;\n\n  @media ",
        " {\n    width: auto;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}






var FooterWrapper = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    componentId: "sc-c311082e-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme === null || theme === void 0 ? void 0 : theme.backgroundSecondary;
}, device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
var LinksWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    align: "flex-start",
    justify: "space-between"
}).withConfig({
    componentId: "sc-c311082e-1"
})(_templateObject1(), device/* default.laptop */.Z.laptop);
var ContentWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-c311082e-2"
})(_templateObject2(), device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
var Logo = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-c311082e-3"
})(_templateObject3(), function(param) {
    var hideOnMobile = param.hideOnMobile;
    return hideOnMobile ? "none" : "block";
}, device/* default.tablet */.Z.tablet, function(param) {
    var hideOnMobile = param.hideOnMobile;
    return !hideOnMobile ? "none" : "block";
}, device/* default.laptop */.Z.laptop);
var LinkWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c311082e-4"
})(_templateObject4(), device/* default.tablet */.Z.tablet);
var FooterLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-c311082e-5"
})(_templateObject5(), device/* default.tablet */.Z.tablet);
var SocialMediaWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    align: "center",
    justify: "space-between",
    py: "10px"
}).withConfig({
    componentId: "sc-c311082e-6"
})(_templateObject6(), function(props) {
    return(// @ts-expect-error
    props.hideOnMobile ? "none" : "flex");
}, device/* default.tablet */.Z.tablet, function(props) {
    return(// @ts-expect-error
    (props.hideOnTablet ? "none" : "flex"));
}, device/* default.laptop */.Z.laptop, function(props) {
    return(// @ts-expect-error
    (!props.hideOnMobile ? "none" : "flex"));
}, device/* default.tablet */.Z.tablet);
var LogoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c311082e-7"
})(_templateObject7(), device/* default.tablet */.Z.tablet);
var MenuWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c311082e-8"
})(_templateObject8(), device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop, Flex/* default */.Z, device/* default.tablet */.Z.tablet, device/* default.tablet */.Z.tablet, function(param) {
    var theme = param.theme;
    return theme === null || theme === void 0 ? void 0 : theme.textSecondary;
});
var DownloadWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    direction: "column"
}).withConfig({
    componentId: "sc-c311082e-9"
})(_templateObject9(), device/* default.tablet */.Z.tablet, device/* default.tablet */.Z.tablet, function(param) {
    var theme = param.theme;
    return theme === null || theme === void 0 ? void 0 : theme.textSecondary;
});
var CopyrightWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-c311082e-10"
})(_templateObject10(), function(param) {
    var theme = param.theme;
    return theme === null || theme === void 0 ? void 0 : theme.backgroundSecondary;
});
var CopyrightContentRow = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).withConfig({
    componentId: "sc-c311082e-11"
})(_templateObject11());
var CopyrightContentWrapper = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).withConfig({
    componentId: "sc-c311082e-12"
})(_templateObject12(), device/* default.tablet */.Z.tablet, function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.name) === "dark" && "\n      filter: saturate(2);\n    ";
});
var CopyImage = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-c311082e-13"
})(_templateObject13(), function(param) {
    var theme = param.theme;
    return theme.name === "dark" ? 0 : 1;
}, device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
var CopyDescription = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    align: "center",
    family: "bold",
    color: "#949494"
}).withConfig({
    componentId: "sc-c311082e-14"
})(_templateObject14(), function(param) {
    var theme = param.theme;
    return theme.textTertiery;
}, device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
var FooterCopyrightImage = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-c311082e-15"
})(_templateObject15(), device/* default.laptop */.Z.laptop);


// EXTERNAL MODULE: ./src/global/HomePageLayout/constants.tsx
var constants = __webpack_require__(56670);
;// CONCATENATED MODULE: ./src/global/HomePageLayout/Footer/SocialMedia.tsx




function SocialMedia(param) {
    var hideOnMobile = param.hideOnMobile, hideOnTablet = param.hideOnTablet;
    return(// @ts-expect-error
    /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaWrapper, {
        hideOnMobile: hideOnMobile,
        hideOnTablet: hideOnTablet,
        children: constants/* socialMediaLinks.map */.v7.map(function(link, idx) {
            return(// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: link.url,
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: link.imageUrl,
                    alt: link.title
                })
            }, idx));
        })
    }));
}
/* harmony default export */ var Footer_SocialMedia = (SocialMedia);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
;// CONCATENATED MODULE: ./src/global/HomePageLayout/Footer/CopyrightLogo.tsx




function CopyrightLogo(param) {
    var title = param.title, imageUrl = param.imageUrl, description = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        align: "center",
        direction: "column",
        style: {
            maxWidth: "147.5px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyImage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: imageUrl,
                    alt: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyDescription, {
                children: description
            })
        ]
    });
}
/* harmony default export */ var Footer_CopyrightLogo = (CopyrightLogo);

;// CONCATENATED MODULE: ./src/global/HomePageLayout/Footer/Copyright.tsx








function Copyright() {
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyrightWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyrightContentWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                span: 24,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CopyrightContentRow, {
                    align: "middle",
                    justify: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            xs: 0,
                            xl: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                alt: "Logo Otoritas Jasa Keuangan",
                                src: "/images/pt-stockbit-sekuritas.svg",
                                style: {
                                    marginRight: 24,
                                    opacity: theme.name === "dark" ? 1 : 0.5,
                                    filter: "brightness(".concat(theme.name === "dark" ? 5 : 1, ")")
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            xs: 24,
                            xl: 18,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                align: "middle",
                                justify: "space-between",
                                gutter: [
                                    20,
                                    0
                                ],
                                children: constants/* copyrightLinks.map */.Hn.map(function(link) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                        span: 4,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_CopyrightLogo, (0,_object_spread/* default */.Z)({}, link), "copyright-".concat(link.title))
                                    }, link.title);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            xs: 24,
                            xl: 0,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                align: "middle",
                                justify: "center",
                                style: {
                                    marginTop: 24
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterCopyrightImage, {
                                        alt: "Logo Otoritas Jasa Keuangan",
                                        src: "/images/pt-stockbit-sekuritas.svg"
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ var Footer_Copyright = (Copyright);

;// CONCATENATED MODULE: ./src/global/HomePageLayout/Footer/index.tsx











var Footer = function(param) {
    var whiteFooterBackground = param.whiteFooterBackground;
    var router = (0,next_router.useRouter)();
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)().name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterWrapper, {
                className: whiteFooterBackground ? "bg-white" : "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                        src: router.pathname === "/tatakelola" ? "/images/stockbit-with-pt.svg" : "/images/stockbit".concat(theme === "dark" ? "-white" : "", ".svg"),
                        alt: "Stockbit"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinksWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                                                src: router.pathname === "/tatakelola" ? "/images/stockbit-with-pt.svg" : "/images/stockbit".concat(theme === "dark" ? "-white" : "", ".svg"),
                                                alt: "Stockbit",
                                                hideOnMobile: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_SocialMedia, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuWrapper, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                            direction: "column",
                                            children: constants/* footerLinks.slice */.dk.slice(0, 4).map(function(link) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: link.url,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        children: link.title
                                                    })
                                                }, link.title);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuWrapper, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                            direction: "column",
                                            children: constants/* footerLinks.slice */.dk.slice(4).map(function(link) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: link.url,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        children: link.title
                                                    })
                                                }, link.title);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_SocialMedia, {
                                        hideOnMobile: true,
                                        hideOnTablet: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DownloadWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                as: "p",
                                                children: "Unduh Aplikasi"
                                            }),
                                            constants/* downloadLinks.map */.ju.map(function(link) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: link.url,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                            src: link.imageUrl,
                                                            alt: link.title,
                                                            width: "120px",
                                                            height: "auto"
                                                        })
                                                    })
                                                }, link.title);
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_SocialMedia, {
                                hideOnTablet: true
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Copyright, {})
        ]
    });
};
Footer.defaultProps = {
    whiteFooterBackground: false
};
/* harmony default export */ var HomePageLayout_Footer = (Footer);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(33082);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/global/HomePageLayout/StartInvesting/styled.ts
var styled = __webpack_require__(81545);
;// CONCATENATED MODULE: ./src/global/HomePageLayout/StartInvesting/index.tsx







var FAQ = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 96704).then(__webpack_require__.bind(__webpack_require__, 96704));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96704)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var SectionTwelve = function(param) {
    var showFAQ = param.showFAQ, startInvestingText = param.startInvestingText;
    var ref = (0,react.useState)(false), viewed = ref[0], setViewed = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
        offset: {
            top: 90,
            bottom: 90
        },
        partialVisibility: true,
        onChange: function(v) {
            return setViewed(function(s) {
                return s || v;
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Wrapper */.im, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Text */.xv, {
                    children: "Daftar sekarang dan bergabunglah dengan puluhan ribu investor lainnya."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/register",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ButtonRegister */.vQ, {
                        className: (0,clsx_m/* default */.Z)("scaleUpX", viewed && "scaleUp"),
                        target: "_blank",
                        rel: "noreferrer",
                        children: startInvestingText || "Buka Rekening Anda"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Text */.xv, {
                    children: [
                        "Dengan mengklik tombol di atas, Anda berarti telah menyetujui",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/terms",
                            children: "Kebijakan Privasi & Persyaratan Layanan Stockbit"
                        }),
                        "."
                    ]
                }),
                showFAQ ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ, {}) : null
            ]
        })
    });
};
/* harmony default export */ var StartInvesting = (SectionTwelve);

// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/constants/data-cy.ts
var data_cy = __webpack_require__(70524);
// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__(14229);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/@deprecated-ui/utils/hexOpacity.js
var hexOpacity = __webpack_require__(84607);
;// CONCATENATED MODULE: ./src/global/HomePageLayout/styled.ts
/* eslint-disable no-confusing-arrow */ /* eslint-disable indent */ /* eslint-disable space-infix-ops */ 
function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n      filter: grayscale(100%);\n      opacity: 0.4;\n      transform: scale(0.9);\n    }\n    50% {\n      filter: grayscale(100%);\n      transform: scale(1.1);\n    }\n    to {\n      filter: grayscale(10%);\n      opacity: 1;\n      transform: scale(1);\n    }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  * {\n      box-sizing: border-box;\n  }\n\n  html, body {\n    width: 100%;\n  }\n\n  html {\n    line-height: 1.15;\n     background: ",
        ";\n  }\n\n  body {\n     &::-webkit-scrollbar {\n        ",
        ";\n      }\n    position: relative;\n    width: 100%;\n    font-family: 'ProximaNovaRg';\n    color:",
        ";\n    background: ",
        ";\n    overflow-x: hidden !important;\n    overflow-y: visible !important;\n    font-size: 17px;\n    margin: 0;\n    padding: 0;\n    height: initial;\n  }\n\n  div {\n    padding: 0;\n    margin: 0;\n  }\n\n  table {\n    border-collapse: separate;\n    text-indent: initial;\n    border-spacing: 2px;\n  }\n\n  tbody {\n    display: table-row-group;\n    vertical-align: middle;\n    border-color: inherit;\n  }\n\n  tr {\n    display: table-row;\n    vertical-align: inherit;\n    border-color: inherit;\n  }\n\n  td {\n    display: table-cell;\n    vertical-align: inherit;\n  }\n\n  audio, video {\n    display: inline-block;\n  }\n\n  img {\n    border-style: none;\n  }\n\n  .fclear:after {\n    content: '';\n    clear: both;\n    display: table;\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100% !important;\n  display: block;\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 5;\n  background: ",
        ";\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 25px;\n  padding-right: 25px;\n  max-width: 1300px;\n\n  @media ",
        " {\n    width: calc(100% - 150px);\n    padding: 5px 0;\n  }\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 15px 0;\n  cursor: pointer;\n\n  @media ",
        " {\n    height: 66px;\n  }\n\n  img {\n    height: 42px;\n\n    @media ",
        " {\n      height: 60px;\n      width: 121.11px;\n    }\n  }\n\n  &.small-logo {\n    height: 45px;\n    display: flex;\n    align-items: center;\n    img {\n      height: 31.5px;\n      animation-timing-function: linear;\n      animation-name: ",
        ";\n      animation-duration: 0.2s;\n      animation-fill-mode: forwards;\n    }\n  }\n"
    ]);
    styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    display: none;\n\n    @media ",
        " {\n      display: block;\n      height: 36px;\n    }\n  }\n"
    ]);
    styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    margin-top: 8px;\n    flex-wrap: wrap;\n    margin-left: 50px;\n  }\n"
    ]);
    styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      b:nth-child(1) {\n        transform: rotate(45deg);\n        position: relative;\n        top: 50%;\n      }\n\n      b:nth-child(2) {\n        display: none;\n      }\n\n      b:nth-child(3) {\n        transform: rotate(-45deg);\n        position: relative;\n        top: -38%;\n      }\n    "
    ]);
    styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 26px;\n  position: absolute;\n  height: 20px;\n  justify-content: space-between;\n  flex-direction: column;\n  right: 25px;\n  top: 25px;\n  display: flex;\n\n  @media ",
        " {\n    display: none;\n  }\n\n  b {\n    height: 2px;\n    background: ",
        ";\n    display: inline-block;\n    width: 100%;\n  }\n\n  ",
        "\n"
    ]);
    styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  text-align: left;\n  white-space: nowrap;\n  &.download {\n    display: flex !important;\n    gap: 8px;\n    align-items: center;\n  }\n\n  @media ",
        " {\n    display: inline-block;\n    color: ",
        ";\n    font-family: 'ProximaNovaLt';\n    font-size: 17px;\n    padding: 10px 20px;\n  }\n\n  @media ",
        " {\n    font-size: 18px;\n  }\n\n  @media only screen and (max-width: 1396px) {\n    padding: 10px 16px;\n  }\n"
    ]);
    styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styled_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border: ",
        ";\n      border-radius: 3px;\n      margin-right: 0px;\n      padding-top: 2px;\n    "
    ]);
    styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styled_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-size: 17px;\n  padding: 0 25px;\n  text-transform: uppercase;\n\n  ",
        "\n\n  @media ",
        " {\n    font-size: 18px;\n  }\n"
    ]);
    styled_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styled_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transition-property: none !important;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  background: ",
        ";\n  height: 100%;\n  position: relative;\n"
    ]);
    styled_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styled_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background:  ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n  padding: 80px 0 0 0;\n  overflow-auto;\n\n  > div {\n    background: ",
        ";\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    padding: 0 10%;\n    border-radius: 4px;\n    max-height: 100%;\n    overflow: auto;\n  }\n"
    ]);
    styled_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styled_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: var(--light-font);\n  font-size: 17px;\n  padding: 20px;\n  text-transform: ",
        ";\n\n  @media ",
        " {\n    font-size: 18px;\n  }\n"
    ]);
    styled_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: ",
        ";\n  height: ",
        ";\n  background: #8228bd;\n  font-size: ",
        ";\n  line-height: ",
        ";\n  padding: ",
        ";\n  border-radius: ",
        ";\n  font-weight: 700;\n  font-family: 'ProximaNovaRg';\n  color: #ffffff;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}





var animatedlogo = (0,styled_components_browser_esm/* keyframes */.F4)(styled_templateObject());
var GlobalStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(styled_templateObject1(), function(param) {
    var theme = param.theme;
    return theme === null || theme === void 0 ? void 0 : theme.background;
}, function(param) {
    var theme = param.theme;
    return (theme === null || theme === void 0 ? void 0 : theme.name) === "dark" && "display: none";
}, function(param) {
    var theme = param.theme;
    return theme === null || theme === void 0 ? void 0 : theme.text;
}, function(param) {
    var theme = param.theme;
    return theme === null || theme === void 0 ? void 0 : theme.background;
});
var styled_ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4c7478e6-0"
})(styled_templateObject2());
var HeaderLanding = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4c7478e6-1"
})(styled_templateObject3(), function(param) {
    var theme = param.theme;
    return theme === null || theme === void 0 ? void 0 : theme.background;
});
var HeaderWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    align: "center",
    justify: "space-between",
    mx: "auto"
}).withConfig({
    componentId: "sc-4c7478e6-2"
})(styled_templateObject4(), device/* default.laptop */.Z.laptop);
var styled_Logo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4c7478e6-3"
})(styled_templateObject5(), device/* default.laptop */.Z.laptop, device/* default.laptop */.Z.laptop, animatedlogo);
var LogoMahakarya = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4c7478e6-4"
})(styled_templateObject6(), device/* default.laptop */.Z.laptop);
var NavbarWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4c7478e6-5"
})(styled_templateObject7(), device/* default.laptop */.Z.laptop);
var HamburgerMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4c7478e6-6"
})(styled_templateObject9(), device/* default.laptop */.Z.laptop, color/* default.gainsboro */.Z.gainsboro, function(param) {
    var open = param.open;
    return open && (0,styled_components_browser_esm/* css */.iv)(styled_templateObject8());
});
var MenuChild = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-4c7478e6-7"
})(styled_templateObject10(), device/* default.tablet */.Z.tablet, function(param) {
    var theme = param.theme;
    return theme.name === "dark" ? "#fff" : "".concat(color/* default.primary */.Z.primary + (0,hexOpacity/* default */.Z)(80));
}, device/* default.laptop */.Z.laptop);
var MenuAuth = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-4c7478e6-8"
})(styled_templateObject12(), color/* default.primary */.Z.primary, function(param) {
    var bold = param.bold;
    return bold ? "var(--bold-font)" : "var(--light-font)";
}, function(param) {
    var bordered = param.bordered, theme = param.theme;
    return bordered && (0,styled_components_browser_esm/* css */.iv)(styled_templateObject11(), theme.border);
}, device/* default.laptop */.Z.laptop);
var FullPage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4c7478e6-9"
})(styled_templateObject13(), function(param) {
    var theme = param.theme;
    return theme === null || theme === void 0 ? void 0 : theme.background;
});
var MobileMenuWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4c7478e6-10"
})(styled_templateObject14(), function(param) {
    var theme = param.theme;
    return theme === null || theme === void 0 ? void 0 : theme.background;
}, function(param) {
    var theme = param.theme;
    return theme === null || theme === void 0 ? void 0 : theme.background;
});
var MobileNav = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-4c7478e6-11"
})(styled_templateObject15(), function(param) {
    var theme = param.theme;
    return theme === null || theme === void 0 ? void 0 : theme.text;
}, function(param) {
    var uppercase = param.uppercase;
    return uppercase && "uppercase";
}, device/* default.tablet */.Z.tablet);
var BetaLabelContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4c7478e6-12"
})(_templateObject16(), function(param) {
    var size = param.size;
    return size === "small" ? "43px" : "86px";
}, function(param) {
    var size = param.size;
    return size === "small" ? "20px" : "40px";
}, function(param) {
    var size = param.size;
    return size === "small" ? "11px" : "22px";
}, function(param) {
    var size = param.size;
    return size === "small" ? "14.85px" : "29.7px";
}, function(param) {
    var size = param.size;
    return size === "small" ? "2px 8px" : "4px 16px";
}, function(param) {
    var size = param.size;
    return size === "small" ? "4px" : "8px";
});


;// CONCATENATED MODULE: ./src/global/HomePageLayout/NavBar.tsx







var NavBar = function(param) {
    var isOpen = param.isOpen, setIsOpen = param.setIsOpen;
    var isLoggedIn = auth/* default.isLoggedIn */.Z.isLoggedIn();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HamburgerMenu, {
                onClick: function() {
                    return setIsOpen(!isOpen);
                },
                open: isOpen,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavbarWrapper, {
                children: [
                    constants/* menus.map */.IJ.map(function(menu) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: menu.url,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuChild, {
                                className: menu.url === "/desktop" ? "download" : "",
                                children: menu.title
                            })
                        }, menu.title);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                        condition: !isLoggedIn,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/register",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuAuth, {
                                    bold: true,
                                    bordered: true,
                                    "data-cy": data_cy/* default.LANDING.REGISTER_BUTTON */.Z.LANDING.REGISTER_BUTTON,
                                    children: "Sign Up"
                                })
                            }, "register"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/login",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuAuth, {
                                    "data-cy": data_cy/* default.LANDING.LOGIN_BUTTON */.Z.LANDING.LOGIN_BUTTON,
                                    children: "Log In"
                                })
                            }, "login")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: isLoggedIn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/stream",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuChild, {
                                    children: "To Stockbit.com"
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var HomePageLayout_NavBar = (NavBar);

;// CONCATENATED MODULE: ./src/global/HomePageLayout/MobileMenu.tsx






var MobileMenu = function() {
    var isLoggedIn = auth/* default.isLoggedIn */.Z.isLoggedIn();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenuWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                constants/* menus.map */.IJ.map(function(menu) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: menu.url,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNav, {
                            href: menu.url,
                            children: menu.title
                        })
                    }, menu.title);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                    condition: !isLoggedIn,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/login",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNav, {
                                uppercase: true,
                                children: "Log In"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/register",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNav, {
                                uppercase: true,
                                children: "Sign Up"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var HomePageLayout_MobileMenu = (MobileMenu);

;// CONCATENATED MODULE: ./src/global/HomePageLayout/Theme.tsx


var lightTheme = {
    text: "#333",
    background: "#fff",
    border: "solid 3px #b2e6d2",
    backgroundSecondary: "#fbfbfb",
    textSecondary: "#777",
    textTertiery: "#949494",
    name: "light"
};
var darkTheme = {
    text: "#fff",
    background: "#141414",
    border: " 1px solid #2E2E2E",
    backgroundSecondary: "#141414",
    textSecondary: "#fff",
    textTertiery: "#fff",
    name: "dark"
};
var Theme = function(param) {
    var children = param.children, theme = param.theme;
    var themeMode = theme === "light" ? lightTheme : darkTheme;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm/* ThemeProvider */.f6, {
        theme: themeMode,
        children: children
    });
};
/* harmony default export */ var HomePageLayout_Theme = (Theme);

;// CONCATENATED MODULE: ./src/global/HomePageLayout/index.tsx











var HomePageLayout = function(props) {
    var router = (0,next_router.useRouter)();
    var children = props.children, showFAQ = props.showFAQ, whiteFooterBackground = props.whiteFooterBackground, startInvestingText = props.startInvestingText, hideStartInvesting = props.hideStartInvesting, _theme = props.theme, theme = _theme === void 0 ? "light" : _theme;
    var ref = (0,react.useState)(false), showLogoSmall = ref[0], setShowLogoSmall = ref[1];
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var handleScroll = function() {
        var scrollY = window.scrollY;
        var show = scrollY >= 450;
        setShowLogoSmall(show);
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    var originalLogoSrc = showLogoSmall ? "/images/stockbitsquare".concat(theme === "dark" ? "-white" : "", ".svg") : "/images/stockbit".concat(theme === "dark" ? "-white" : "", ".svg");
    var logoSrc = router.pathname === "/tatakelola" ? "/images/stockbit-with-pt.svg" : originalLogoSrc;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomePageLayout_Theme, {
            theme: theme,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyle, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_ContentWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLanding, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Logo, {
                                        className: showLogoSmall ? "small-logo" : null,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                    src: logoSrc,
                                                    alt: "Stockbit logo"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageLayout_NavBar, {
                                        setIsOpen: setIsOpen,
                                        isOpen: isOpen
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullPage, {
                            children: [
                                isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageLayout_MobileMenu, {}),
                                children,
                                !hideStartInvesting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StartInvesting, {
                                    showFAQ: showFAQ,
                                    startInvestingText: startInvestingText
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageLayout_Footer, {
                                    whiteFooterBackground: whiteFooterBackground
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var global_HomePageLayout = (HomePageLayout);


/***/ }),

/***/ 579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86123);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);





var Image = function(_param) {
    var src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "alt"
    ]);
    var source = src || "";
    var isBlob = source.startsWith("blob:");
    var isBase64 = source.startsWith("data:");
    var isUrl = source.startsWith("http") || source.startsWith("//");
    if (source && !isUrl && !isBlob && !isBase64) {
        var separator = source.startsWith("/") ? "" : "/";
        source = "".concat(constants_app__WEBPACK_IMPORTED_MODULE_1__/* .assetPrefix */ .Vc).concat(separator).concat(source);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: source,
        alt: alt
    }, rest));
};
Image.defaultProps = {
    alt: ""
};
Image.propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 14229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);
/* harmony import */ var date_fns_isAfter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42699);
/* harmony import */ var constants_localstorage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44252);
/* harmony import */ var features_orderbook_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51346);
/* harmony import */ var _general__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42227);





function getToken() {
    if (!(0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        return {
            accessToken: {
                token: null,
                expiry: null,
                isValid: null
            },
            refresh: {
                token: null,
                expiry: null,
                isValid: null
            }
        };
    }
    var ls = localStorage;
    // set cookies
    // format date from backend is still in seconds, while
    // JS' date is in miliseconds format, thus multiply the date by 1000
    var accessToken = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx] ? (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx]) : null;
    var accessTokenExp = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0] ? parseInt((0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0]), 10) : null;
    var refreshToken = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4] ? (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4]) : null;
    var refreshTokenExp = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv] ? parseInt((0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv]), 10) : null;
    // check expiry
    var currentTime = Date.now();
    var isAccessTokenValid = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(accessTokenExp, currentTime);
    var isRefreshTokenValid = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(refreshTokenExp, currentTime);
    return {
        accessToken: {
            token: accessToken,
            expiry: accessTokenExp,
            isValid: isAccessTokenValid
        },
        refresh: {
            token: refreshToken,
            expiry: refreshTokenExp,
            isValid: isRefreshTokenValid
        }
    };
}
function saveToken(param) {
    var accessToken = param.accessToken, accessTokenExp = param.accessTokenExp, refreshToken = param.refreshToken, refreshTokenExp = param.refreshTokenExp, accessUser = param.accessUser;
    if (!(0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        return;
    }
    if (accessUser) {
        localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessUser);
    }
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessToken);
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessTokenExp.toString());
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(refreshToken);
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(refreshTokenExp.toString());
}
function updateAccessUser(accessUser) {
    if ((0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessUser);
    }
}
function destroyToken() {
    if ((0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv);
        localStorage.removeItem("stbx-active-indexwatchlist");
        localStorage.removeItem("stbx-active-watchlist");
        localStorage.removeItem("stbx-active-widget");
        localStorage.removeItem("stbx-active-stream-header");
        localStorage.removeItem("stbx-active-stream");
        localStorage.removeItem("trade-orderbook-show-confirmation");
        localStorage.removeItem("tradeIsLogin");
        localStorage.removeItem("tradingVersion");
        localStorage.removeItem("tradingAccountType");
        localStorage.removeItem("taps");
        localStorage.removeItem("tradingBroker");
        localStorage.removeItem("lastTradingAccountType");
        localStorage.removeItem("register_trading_useractive_sinarmas");
        localStorage.removeItem("register_trading_sinarmas");
        localStorage.removeItem("register_trading_useractive");
        localStorage.removeItem("tradingBrokerList");
        localStorage.removeItem("financials-panel-amount");
        localStorage.removeItem("financials-panel-currency");
        localStorage.removeItem("financials-panel-datatype");
        localStorage.removeItem("financials-panel-lang");
        localStorage.removeItem("financials-panel-ordertype");
        localStorage.removeItem("financials-panel-reportype");
        localStorage.removeItem("financials-panel-rounding-count");
        localStorage.removeItem("financials-panel-rounding-symbol");
        localStorage.removeItem("financials-panel-statetype");
        localStorage.removeItem("crisp");
        localStorage.removeItem("formula");
        localStorage.removeItem("stbx-active-trending-date");
        localStorage.removeItem("ws");
        features_orderbook_utils__WEBPACK_IMPORTED_MODULE_1__/* .localStorageOrderbookHandler.remove */ .Ku.remove();
        localStorage.removeItem("orderbooklistID");
        localStorage.removeItem("orderbooklistName");
    }
}
/**
 * getUserAccess
 * to get user data from auth login
 * @param {*} ctx
 */ function getUserAccess() {
    return (0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)() && localStorage && localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns] ? (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns]) : {};
}
var setLocalCrispSettings = function(crisp) {
    localStorage.location = window.location.origin;
    localStorage.crisp = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(crisp);
};
var setLocalIntercomSettings = function(intercom) {
    localStorage.location = window.location.origin;
    localStorage.intercom = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(intercom);
};
var isLoggedIn = function() {
    return (0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)() && Boolean(localStorage === null || localStorage === void 0 ? void 0 : localStorage.at);
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    isLoggedIn: isLoggedIn,
    getToken: getToken,
    saveToken: saveToken,
    destroyToken: destroyToken,
    getUserAccess: getUserAccess,
    updateAccessUser: updateAccessUser,
    setLocalCrispSettings: setLocalCrispSettings,
    setLocalIntercomSettings: setLocalIntercomSettings
});


/***/ })

}]);